/* Isolated FAQ interaction; the page contains no imported runtime or trackers. */
(() => {
  function bindFiveReasons(root = document) {
    root.querySelectorAll('[data-five-reasons-faq]').forEach((button) => {
      if (button.dataset.fiveReasonsBound) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.dataset.fiveReasonsBound = 'true';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.closest('#five-reasons-page')?.querySelectorAll('[data-five-reasons-faq]').forEach((other) => {
          if (other === button) return;
          other.setAttribute('aria-expanded', 'false');
          const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
          const otherIcon = other.querySelector('svg');
          otherIcon?.classList.remove('lucide-chevron-up');
          otherIcon?.classList.add('lucide-chevron-down');
          otherIcon?.querySelector('path')?.setAttribute('d', 'm6 9 6 6 6-6');
        });
        button.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        const icon = button.querySelector('svg');
        icon?.classList.toggle('lucide-chevron-up', expanded);
        icon?.classList.toggle('lucide-chevron-down', !expanded);
        icon?.querySelector('path')?.setAttribute('d', expanded ? 'm18 15-6-6-6 6' : 'm6 9 6 6 6-6');
      });
    });
  }
  bindFiveReasons();
  document.addEventListener('shopify:section:load', (event) => bindFiveReasons(event.target));
})();
